import L from 'leaflet';
import markerIconUrl from '../svg/marker-cobalto.svg';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mir-map]').forEach((el) => {
    const zoom = parseInt(el.dataset.zoom || '14', 10) || 14;
    const title = el.dataset.title || '';
    const pointsRaw = el.dataset.points || '[]';
    const singleLat = parseFloat(el.dataset.lat || '0');
    const singleLng = parseFloat(el.dataset.lng || '0');

    let points = [];
    try {
      points = JSON.parse(pointsRaw);
    } catch (error) {
      points = [];
    }

    if (!Array.isArray(points) || points.length === 0) {
      if (singleLat && singleLng) {
        points = [{ lat: singleLat, lng: singleLng, title }];
      }
    }

    if (!points.length) return;

    const map = L.map(el).setView([points[0].lat, points[0].lng], zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    const markerIcon = L.icon({
        iconUrl: markerIconUrl,
        iconSize: [56, 75],
        iconAnchor: [28, 75],
        popupAnchor: [0, -75],
        className: 'it-map-marker color-cobalto'
    });

    const latLngs = [];
    points.forEach((point) => {
      const lat = parseFloat(point.lat || 0);
      const lng = parseFloat(point.lng || 0);
      if (!lat || !lng) return;

      const marker = L.marker([lat, lng], { icon: markerIcon }).addTo(map);
      if (point.title) {
        marker.bindPopup(point.title);
      }
      latLngs.push([lat, lng]);
    });

    if (!latLngs.length) return;

    const routeStyle = {
      color: '#1f3c88',
      weight: 4,
      opacity: 0.85
    };

    const drawDirectLine = () => {
      if (latLngs.length > 1) {
        L.polyline(latLngs, routeStyle).addTo(map);
      }
    };

    const drawWalkingRoute = async () => {
      if (latLngs.length <= 1) return;

      const coords = latLngs.map(([lat, lng]) => `${lng},${lat}`).join(';');
      const url = `https://router.project-osrm.org/route/v1/foot/${coords}?overview=full&geometries=geojson&steps=false`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          drawDirectLine();
          return;
        }

        const payload = await response.json();
        const route = payload && Array.isArray(payload.routes) ? payload.routes[0] : null;
        const coordinates = route && route.geometry && Array.isArray(route.geometry.coordinates)
          ? route.geometry.coordinates
          : [];

        if (coordinates.length < 2) {
          drawDirectLine();
          return;
        }

        const routeLatLngs = coordinates.map(([lng, lat]) => [lat, lng]);
        L.polyline(routeLatLngs, routeStyle).addTo(map);
      } catch (error) {
        drawDirectLine();
      }
    };

    drawWalkingRoute();

    const bounds = L.latLngBounds(latLngs);
    map.fitBounds(bounds, { padding: [28, 28], maxZoom: zoom });
  });
});
